import { SET_REFUND_LOADING } from './actions';
const initialState = new Set();
function loadingReducer(state = initialState, { type, payload }) {
    switch (type) {
        case SET_REFUND_LOADING: {
            const { operation, status } = payload;
            if (status && state.has(operation)) {
                return state;
            }
            if (!status && !state.has(operation)) {
                return state;
            }
            const newState = new Set(state);
            if (status) {
                newState.add(operation);
            }
            else {
                newState.delete(operation);
            }
            return newState;
        }
        default:
            return state;
    }
}
export default loadingReducer;
